import { useTranslation } from 'react-i18next'

import { FloatingTooltip } from '../../Floating'
import { InputField } from '../../Input'
import { List } from '../../List'
import Text from '../../Text'

import { VARIABLES_LIST_HEIGHT } from './EmailGoogleTemplateExternalVariablesList.constants'

import * as styles from './EmailGoogleTemplateExternalVariablesList.module.css'

function EmailGoogleTemplateExternalVariablesList(props) {
  const { templateName, variables } = props

  const { t } = useTranslation()

  function getHandleFocus(field) {
    return () => {
      props.onHighlightVariable(field)
    }
  }

  return (
    <List
      className={styles.variables}
      itemsWrapperClassName={styles.itemsWrapper}
      maxHeight={VARIABLES_LIST_HEIGHT}
      prependItem={
        <div className={styles.templateNameContainer}>
          <FloatingTooltip
            content={t('Emails.ExternalVariableTemplateNameLabelKey')}
          >
            <Text className={styles.label}>
              {t('Emails.ExternalVariableTemplateNameLabelKey')}
            </Text>
          </FloatingTooltip>
          <FloatingTooltip content={templateName}>
            <Text className={styles.templateName}>{templateName}</Text>
          </FloatingTooltip>
        </div>
      }
    >
      {Object.keys(variables).map(field => (
        <div className={styles.variableItem} key={field}>
          <FloatingTooltip content={field}>
            <Text className={styles.label}>{field}</Text>
          </FloatingTooltip>
          <InputField
            name={field}
            placeholder={t('Emails.ExternalVariablePlaceholderKey')}
            value={variables[field]}
            onChange={props.onChangeVariables}
            onFocus={getHandleFocus(field)}
          />
        </div>
      ))}
    </List>
  )
}

export default EmailGoogleTemplateExternalVariablesList
